const baseUrl = import.meta.env.VITE_BASE_URL as string
const apiBaseUrl = import.meta.env.VITE_API_BASE_URL as string
const apiKey = import.meta.env.VITE_API_KEY as string
const recaptchaSiteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY as string
const loginRedirectUrl = import.meta.env.VITE_LOGIN_REDIRECT_URL as string
const socketUrl = import.meta.env.VITE_SOCKET_URL as string
const toastLimit = 1
const previewVideo = '/video-loop.webm'
const previewVideos = ['SgABpYfaYoU', '4ID1rnpGMS8', '-EkTJMr92lM', 'KhNFjQRuUZk']

// jba-web-api (unit pickup Kode Unik validate/redeem), separate service from antrian-system's apiBaseUrl above.
const pickupApiBaseUrl = import.meta.env.VITE_PICKUP_API_BASE_URL as string
const pickupApiKey = import.meta.env.VITE_PICKUP_API_KEY as string

export {
  apiBaseUrl,
  apiKey,
  baseUrl,
  loginRedirectUrl,
  pickupApiBaseUrl,
  pickupApiKey,
  previewVideo,
  previewVideos,
  recaptchaSiteKey,
  socketUrl,
  toastLimit,
}
